import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAll = (state, { allAuditLogs }) => {
  if (!allAuditLogs) return state;
  return state.merge({ allAuditLogs });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setUsers = (state, { users }) => {
  return state.merge({ users });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_USERS,
    actionFunction: setUsers,
  },
];
